export enum SidebarEnum {
	News = 'news',
	Preview = 'preview',
	PreviewWithStatistics = 'previewWithStatistics',
	PreviewNewsStatistics = "previewNewsStatistics"
}

export type SidebarType = SidebarEnum | undefined;
